import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { MechanicModel } from 'src/app/models/archive/mechanic.model';
import { MechanicService } from 'src/app/services/archive/mechanic.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { UpdateDocumentMechanicComponent } from '../update-document-mechanic/update-document-mechanic.component';

@Component({
  selector: 'app-register-mechanic',
  templateUrl: './register-mechanic.component.html',
  styleUrls: ['./register-mechanic.component.scss'],
  standalone: false
})
export class RegisterMechanicComponent implements OnInit {

  @ViewChild('changeDocumentModal') changeDocumentModalComponent?: CustomModalComponent | null = null;
  branchId: number = 0;
  codeNameBranch: string | undefined = '';
  companyId: number = 0;
  componentChangeDocumentModal = UpdateDocumentMechanicComponent;
  disabledForm: boolean = false;
  formMechanic: FormGroup = new FormGroup({});
  inputsForChangeDocumentModals$ = new BehaviorSubject<any>({
    mechanicContract: new MechanicModel()
  });
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listTypeDocument: any[] = [];
  nameWindow: string = 'Captura Mecánicos';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  stateMechanic: string = '';
  titleState: string = '';
  mechanicId: number = 0;
  url: string = 'mechanic';
  mechanicContract: MechanicModel = new MechanicModel();

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private mechanicService: MechanicService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(new MechanicModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.mechanicId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  changeBranch(branchId: number) {
    this.branchId = branchId;
    this.mechanicContract = new MechanicModel();
    this.mechanicContract.branchId = branchId;
    this.validateForm(this.mechanicContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  changeDocument(document: string) {
    if (document !== '') {
      const branchId = this.formMechanic.get("branchId")?.value;
      const typeDocumentId = this.formMechanic.get("typeDocumentId")?.value;
      this.getMechanicByDocument(branchId, document, typeDocumentId);
    } else {
      this.createNewRegister();
    }
  }

  async changeStateMechanic() {
    if (!this.mechanicId || this.mechanicId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un mecánico.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para cambiar el estado del mecánico. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.mechanicService.setActiveMechanic(this.mechanicContract.mechanicId));
      this.mechanicContract = response;
      this.validateForm(this.mechanicContract);
      if (response.active) {
        this.toastHandlerService.showToast(
          'success',
          'El mecánico fue activado exitosamente.'
        );
      } else {
        this.toastHandlerService.showToast(
          'success',
          'El mecánico fue desactivado exitosamente.'
        );
      }
    } catch (error) {
      console.error('Error al cambiar el estado del mecánico.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear mecánicos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.mechanicId = 0;
    this.mechanicContract = new MechanicModel();
    this.mechanicContract.branchId = this.branchId;
    this.validateForm(this.mechanicContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.mechanicId || this.mechanicId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un mecánico.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar mecánicos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el mecánico?')) {
      try {
        await firstValueFrom(this.mechanicService.deleteMechanic(this.mechanicContract.mechanicId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'El mecánico fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el mecánico.', error);
      }
    };
  }

  async getAllLists() {
    try {
      const [branches, typeDocuments] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.mechanicService.getAllTypeDocumentsForSelectAsync()),
      ]);
      this.listBranches = branches;
      this.listTypeDocument = typeDocuments;
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getMechanicById() {
    try {
      const response = await firstValueFrom(this.mechanicService.getMechanicById(this.mechanicId));
      this.mechanicContract = response;
      this.validateForm(response);
    } catch (error) {
      console.error('Error al obtener el mecánico por Id.', error);
    }
  }

  async getMechanicByDocument(branchId: number, document: string, typeDocumentId: number) {
    try {
      const mechanic = await firstValueFrom(this.mechanicService.getMechanicByDocumentAsync(branchId, document));
      if (mechanic.mechanicId == 0) {
        this.mechanicContract.typeDocumentId = typeDocumentId;
        this.mechanicContract.document = mechanic.document;
        this.mechanicContract.digitVerification = mechanic.digitVerification;
      } else {
        this.mechanicId = mechanic.mechanicId;
        this.mechanicContract = mechanic;
      }
      this.validateForm(this.mechanicContract);
      this.location.replaceState(`/${this.url}/register/${this.mechanicId}`);
    } catch (error) {
      console.error('Error al obtener el mecánico por documento.', error);
      this.formMechanic.controls['digitVerification'].patchValue(null);
    }
  }

  async getMechanicByName() {
    try {
      const branchId = this.formMechanic.get('branchId')?.value;
      const name = this.formMechanic.get('name')?.value;
      const response = await firstValueFrom(this.mechanicService.getMechanicByName(branchId, name));
      if (response) {
        if (!await this.confirmDialogService.confirm(
          `El mecánico con doc. ${response.document} - ${response.name} tiene el mismo nombre. ¿Desea continuar?`
        )) {
          this.formMechanic.controls['name'].patchValue(null);
        }
      }
    } catch (error) {
      console.error('Error al consultar el mecánico por nombre.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(
          filter(branch => !!branch && branch.branchId !== 0)
        )
      );
      this.branchId = response.branchId;
      this.companyId = response.companyId;
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getPermissionProfileByUrl(),
      this.getAllLists(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.mechanicId !== null && this.mechanicId !== 0) {
      await this.getMechanicById();
    } else {
      this.createNewRegister();
    }
  }

  openChangeDocumentModal() {
    if (!this.mechanicId || this.mechanicId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un mecánico.'
      );
      return;
    }
    if (!this.mechanicContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        `El mecánico se encuentra inactivo.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para la edición de mecánico. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.inputsForChangeDocumentModals$.next({ mechanicContract: this.mechanicContract });
    this.changeDocumentModalComponent && this.changeDocumentModalComponent.show();
  }

  async send() {
    this.validateFormControls();
    if (this.formMechanic.valid) {
      const modelMechanic = this.formMechanic.getRawValue() as MechanicModel;
      if (modelMechanic.alterPhone == "") modelMechanic.alterPhone = null;
      if (this.mechanicId == 0) {
        try {
          const response = await firstValueFrom(this.mechanicService.createMechanic(modelMechanic));
          this.mechanicId = response.mechanicId;
          this.mechanicContract = response;
          this.validateForm(this.mechanicContract);
          this.location.replaceState(`/${this.url}/register/${this.mechanicId}`);
          this.toastHandlerService.showToast(
            'success',
            `El mecánico fue creado exitosamente.`
          );
        } catch (error) {
          console.error('Error al crear el mecánico.', error);
        }
      } else {
        this.mechanicContract.branchId = modelMechanic.branchId;
        this.mechanicContract.typeDocumentId = modelMechanic.typeDocumentId;
        this.mechanicContract.document = modelMechanic.document;
        this.mechanicContract.digitVerification = modelMechanic.digitVerification;
        this.mechanicContract.name = modelMechanic.name;
        this.mechanicContract.contact = modelMechanic.contact;
        this.mechanicContract.address = modelMechanic.address;
        this.mechanicContract.active = modelMechanic.active;
        this.mechanicContract.swExternal = modelMechanic.swExternal;
        this.mechanicContract.phone = modelMechanic.phone;
        this.mechanicContract.alterPhone = modelMechanic.alterPhone;
        try {
          const response = await firstValueFrom(this.mechanicService.updateMechanic(this.mechanicContract));
          this.mechanicContract = response;
          this.validateForm(this.mechanicContract);
          this.toastHandlerService.showToast(
            'success',
            `El mecánico fue modificado exitosamente.`
          );
        } catch (error) {
          console.error('Error al modificar el mecánico.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      typeDocumentId: {
        required: 'El campo Tipo de Documento es obligatorio.',
        min: 'Debe seleccionar un Tipo de Documento válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El campo Dígito de Verificación es obligatorio.',
        min: 'El Dígito de Verificación no puede ser menor que 0.',
        max: 'El Dígito de Verificación no puede ser mayor que 9.'
      },
      name: {
        required: 'El campo Nombre del Mecánico es obligatorio.',
        maxlength: 'El Nombre del Mecánico no puede tener más de 75 caracteres.'
      },
      phone: {
        required: 'El campo Teléfono es obligatorio.',
        minlength: 'El Teléfono debe tener al menos 7 caracteres.',
        maxlength: 'El Teléfono no puede tener más de 15 caracteres.'
      },
      alterPhone: {
        minlength: 'El Teléfono alterno debe tener al menos 7 caracteres.',
        maxlength: 'El Teléfono alterno no puede tener más de 15 caracteres.'
      },
      contact: {
        maxlength: 'El campo Contacto no puede tener más de 75 caracteres.'
      },
      address: {
        maxlength: 'La Dirección no puede tener más de 70 caracteres.'
      },
      active: {
        required: 'Debe indicar si el mecánico está activo o inactivo.'
      },
      swExternal: {
        required: 'Debe indicar si el mecánico es externo o no.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formMechanic.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  reloadMechanic(event: any) {
    if (event.reload) {
      this.mechanicContract = event.mechanicModel;
      this.validateForm(this.mechanicContract);
    }
  }

  updateFormState() {
    if (this.mechanicContract.active) {
      this.disabledForm = false;
      this.titleState = 'Inactivar';
      this.severityState = 'success';
      this.stateMechanic = 'Activo';
      setTimeout(() => this.formMechanic.enable());
    } else {
      this.disabledForm = true;
      this.titleState = 'Activar';
      this.severityState = 'danger';
      this.stateMechanic = 'Inactivo';
      setTimeout(() => {
        this.formMechanic.disable(),
          this.formControlStateService.setControlState(this.formMechanic, ['branchId', 'document'], true)
      });
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formMechanic.disable());
    }
    setTimeout(() => this.formMechanic.controls["digitVerification"].disable());
  }

  validateForm(mechanic: MechanicModel) {
    this.formMechanic = this.formBuilder.group({
      branchId: [mechanic.branchId, [Validators.required]],
      typeDocumentId: [mechanic.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [mechanic.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [mechanic.digitVerification, [Validators.required, Validators.min(0), Validators.max(9)]],
      name: [mechanic.name, [Validators.required, Validators.maxLength(75)]],
      phone: [mechanic.phone, [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      alterPhone: [mechanic.alterPhone, [Validators.minLength(7), Validators.maxLength(15)]],
      contact: [mechanic.contact, [Validators.maxLength(75)]],
      address: [mechanic.address, [Validators.maxLength(70)]],
      active: [mechanic.active],
      swExternal: [mechanic.swExternal]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formMechanic.controls).forEach((key) => {
      const control = this.formMechanic.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
